// Mock data for SyrVerse Landing Page

export const companyInfo = {
  name: "SyrVerse",
  logo: "https://customer-assets.emergentagent.com/job_16dfcaef-70c8-4c39-b8ef-d31a85d1a341/artifacts/i1pg77u5_Asset%201%404x221.png",
  tagline: {
    ar: "نصنع المستقبل الرقمي في سوريا",
    en: "Crafting Digital Future in Syria"
  },
  description: {
    ar: "شركة متخصصة بإنتاج التطبيقات الخدمية في سوريا",
    en: "A company specialized in service applications production in Syria"
  }
};

export const apps = [
  {
    id: 1,
    name: "ShopVerse",
    icon: "https://customer-assets.emergentagent.com/job_16dfcaef-70c8-4c39-b8ef-d31a85d1a341/artifacts/m0jw9zi8_profile-pic.png",
    link: "https://www.syrverse.com/shopverse",
    description: {
      ar: "تطبيق التسوق الذكي",
      en: "Smart Shopping App"
    }
  }
];

export const contactInfo = {
  social: [
    {
      name: "Facebook",
      url: "https://www.facebook.com/SyrVerse.sy",
      icon: "facebook"
    },
    {
      name: "Instagram",
      url: "https://www.instagram.com/syrverse_sy/",
      icon: "instagram"
    }
  ],
  email: "info@syrverse.com",
  team: [
    {
      name: {
        ar: "براء الطبشي",
        en: "Baraa Tabshi"
      },
      phone: "+963 962 086 285"
    },
    {
      name: {
        ar: "حمزة الخالد",
        en: "Hamza Al-Khaled"
      },
      phone: "+963 994 700 302"
    }
  ]
};

export const translations = {
  ar: {
    nav: {
      home: "الرئيسية",
      about: "من نحن",
      apps: "تطبيقاتنا",
      contact: "تواصل معنا"
    },
    hero: {
      title: "نصنع المستقبل الرقمي",
      subtitle: "شركة متخصصة بإنتاج التطبيقات الخدمية في سوريا"
    },
    apps: {
      title: "تطبيقاتنا",
      viewApp: "اكتشف التطبيق"
    },
    contact: {
      title: "تواصل معنا",
      email: "البريد الإلكتروني",
      phone: "أرقام التواصل",
      followUs: "تابعنا"
    },
    footer: {
      rights: "جميع الحقوق محفوظة"
    }
  },
  en: {
    nav: {
      home: "Home",
      about: "About Us",
      apps: "Our Apps",
      contact: "Contact Us"
    },
    hero: {
      title: "Crafting Digital Future",
      subtitle: "A company specialized in service applications production in Syria"
    },
    apps: {
      title: "Our Apps",
      viewApp: "Discover App"
    },
    contact: {
      title: "Contact Us",
      email: "Email",
      phone: "Phone Numbers",
      followUs: "Follow Us"
    },
    footer: {
      rights: "All Rights Reserved"
    }
  }
};
